import PropTypes from 'prop-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import Link from '../../../Core/Link';
import RichText from '../../../Core/RichText';

import {
  Card,
  Icon,
  Heading,
  Subheading,
  CardFooter,
  BottomCopy,
} from './styles';

const header = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
  },
};

const subheader = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Subheading>{children}</Subheading>,
  },
};

const body = {
  renderNode: {
    [BLOCKS.UL_LIST]: (_, children) => (
      <ul className="no-bullets">{children}</ul>
    ),
    [INLINES.HYPERLINK]: (node, children) => {
      const { data } = node;
      return (
        <Link className="rich-text-link" to={data.uri} fontSize="inherit">
          {children}
        </Link>
      );
    },
  },
};

const bottomOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <BottomCopy>{children}</BottomCopy>,
  },
};

const Testimonial = ({ data = null }) => {
  if (!data) return null;

  const {
    id,
    component,
    subheading,
    imageDam,
    heading,
    bodyCopy,
    bottomCopy,
    textAlignment,
  } = data;

  return (
    <Card key={id} className={component} textAlignment={textAlignment}>
      {imageDam && <Icon src={imageDam} />}
      {heading && <RichText document={heading} options={header} />}
      {subheading && <RichText document={subheading} options={subheader} />}
      {bodyCopy && <RichText document={bodyCopy} options={body} />}
      {bottomCopy && (
        <CardFooter>
          <RichText document={bottomCopy} options={bottomOptions} />
        </CardFooter>
      )}
    </Card>
  );
};

Testimonial.propTypes = {
  data: PropTypes.shape(),
};

export default Testimonial;
